import { POST } from '@/api'
import { cloneDeep } from 'lodash'

export default {
  namespaced: true,
  state: {
    data: [],
    origin: [],
    dataDetail: {},
    originDetail: {},
    busy: false,
  },
  mutations: {
    set(state, data) {
      state.data = cloneDeep(data)
      state.origin = data
    },
    resetStatus(state) {
      state.data = cloneDeep(state.origin)
    },
    setDetail(state, data) {
      state.dataDetail = cloneDeep(data)
      state.originDetail = data
    },
    resetStatusDetail(state) {
      state.dataDetail = cloneDeep(state.originDetail)
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  actions: {
    async get(store, { readonly = false } = {}) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)
      const { status, message, data } = await POST('/api/web/store/businesshour/list', { readonly })

      if (status === 200) {
        commit('set', data.businesshours)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async getDetail(store, { readonly = false } = {}) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)
      const { status, message, data } = await POST('/api/web/store/businesshour/detail/list', { readonly })
      if (status === 200) {
        commit('setDetail', data.businesshourDetails)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async save({ commit, state }) {
      if (state.busy) return false
      commit('busy', true)
      const { status, message } = await POST('/api/web/store/businesshour/register', {
        lunch_timer: state.dataDetail.lunchTimer,
        timer: state.dataDetail.timer,
        reset_time: state.dataDetail.resetTime,
        lunch_rotation: state.dataDetail.lunchRotation,
        dinner_rotation: state.dataDetail.dinnerRotation,
        day_display_time: state.dataDetail.dayDisplayTime,
        other_display_time: state.dataDetail.otherDisplayTime,
        businesshours: state.data,
      })

      if (status !== 200) commit('app/error', { status, message }, { root: true })

      commit('busy', false)
      return status === 200
    },
  },
}
